import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { EcwOAuthResponse } from "@thkStore/Store/Widgets/ExemptionCertificateWizard/Handlers/LoadEcwAuthentication";
import { Draft } from "immer";

export interface ExemptionCertificateWizardState {
    isLoading: boolean;
    ecwAuthentication?: EcwOAuthResponse;
    error?: string;
}

const initialState: ExemptionCertificateWizardState = {
    isLoading: false,
};

const exemptionCertificateWizardReducer = createTypedReducerWithImmer(initialState, {
    "Widgets/ExemptionCertificateWizard/BeginLoadAuthentication": (
        draft: Draft<ExemptionCertificateWizardState>,
    ) => {
        draft.isLoading = true;
        draft.error = undefined;
    },
    "Widgets/ExemptionCertificateWizard/CompleteLoadAuthentication": (
        draft: Draft<ExemptionCertificateWizardState>,
        action: { result: EcwOAuthResponse },
    ) => {
        draft.isLoading = false;
        draft.ecwAuthentication = action.result;
    },
    "Widgets/ExemptionCertificateWizard/FailLoadAuthentication": (
        draft: Draft<ExemptionCertificateWizardState>,
        action: { error: string },
    ) => {
        draft.isLoading = false;
        draft.error = action.error;
    },
});

(reducers as any).exemptionCertificateWizard = exemptionCertificateWizardReducer;

export type ApplicationExemptionCertificateWizardState = {
    exemptionCertificateWizard: ExemptionCertificateWizardState;
} & ApplicationState;
